export { default } from "./about-century-indonesia"